var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLivologo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 76,
    viewBox: "0 0 203 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0586 70.1964C74.0197 66.2353 76 60.8002 76 53.8911V22.1092C76 15.2001 74.0197 9.81094 70.0586 5.94185C66.1892 1.98061 60.8002 0 53.8911 0H22.1092C15.2001 0 9.76486 1.98061 5.80363 5.94185C1.93455 9.81094 0 15.2001 0 22.1092V53.8911C0 60.8002 1.93455 66.2353 5.80363 70.1964C9.76486 74.0658 15.2001 76 22.1092 76H53.8911C60.8002 76 66.1892 74.0658 70.0586 70.1964Z",
    fill: "url(#paint0_linear_823_2987)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.642 17.4414H21.4894C19.874 17.4414 18.5645 18.751 18.5645 20.3664V33.6441C18.5645 35.2596 19.874 36.5691 21.4894 36.5691H33.642C35.2574 36.5691 36.567 35.2596 36.567 33.6441V20.3664C36.567 18.751 35.2574 17.4414 33.642 17.4414Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.642 39.9414H21.4894C19.874 39.9414 18.5645 41.251 18.5645 42.8664V56.1441C18.5645 57.7596 19.874 59.0691 21.4894 59.0691H33.642C35.2574 59.0691 36.567 57.7596 36.567 56.1441V42.8664C36.567 41.251 35.2574 39.9414 33.642 39.9414Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.017 39.9414H42.8644C41.249 39.9414 39.9395 41.251 39.9395 42.8664V56.1441C39.9395 57.7596 41.249 59.0691 42.8644 59.0691H55.017C56.6324 59.0691 57.942 57.7596 57.942 56.1441V42.8664C57.942 41.251 56.6324 39.9414 55.017 39.9414Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.472 58.3556C110.809 58.7534 108.266 58.952 105.841 58.952C103.456 58.952 101.45 58.1374 99.8198 56.5076C98.1906 54.8782 97.376 52.7122 97.376 50.0097V16.625H107.808V48.5193C107.808 49.1154 108.007 49.6122 108.405 50.0097C108.802 50.4071 109.299 50.6058 109.895 50.6058H113.472V58.3556Z",
    fill: "#0C344E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.371 28.5481V58.9518H119.938V36.5962V28.5481H130.371ZM119.938 16.625H130.371V24.9711H119.938V16.625Z",
    fill: "#0C344E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.742 27.3125H168.77L156.847 58.9086H144.924L133.001 27.3125H144.03L150.886 48.7741L157.742 27.3125Z",
    fill: "#0C344E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M202.602 49.375C202.602 52.3558 201.748 54.7007 200.039 56.4095C198.369 58.0786 196.044 58.9135 193.064 58.9135H179.352C176.371 58.9135 174.027 58.0786 172.318 56.4095C170.648 54.7007 169.813 52.3558 169.813 49.375V35.6634C169.813 32.6827 170.648 30.3577 172.318 28.6885C174.027 26.9794 176.371 26.125 179.352 26.125H193.064C196.044 26.125 198.369 26.9794 200.039 28.6885C201.748 30.3577 202.602 32.6827 202.602 35.6634V49.375ZM192.169 36.5577C192.169 34.968 191.375 34.173 189.785 34.173H182.631C181.041 34.173 180.247 34.968 180.247 36.5577V48.4808C180.247 50.0705 181.041 50.8654 182.631 50.8654H189.785C191.375 50.8654 192.169 50.0705 192.169 48.4808V36.5577Z",
    fill: "#0C344E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_823_2987",
    x1: 38.0001,
    y1: 0,
    x2: 38.0001,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8B02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivologo);
export default __webpack_public_path__ + "static/media/livologo.9dc89eaf76ee7288e43ee9f04c354b51.svg";
export { ForwardRef as ReactComponent };